<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 21"
    width="13px"
    height="21px"
    class="breadcrumbs-arrow" :class="checkSide">
    <path
        :fill="color"
        fill-rule="evenodd"
        d="M9.90638279.9899495L0 10.5l9.90638279 9.5100505c.57620221.5531497 1.48620921.5531497 2.06241151 0 .546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057L4.12482294 10.5l7.84397136-7.5301515c.546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057c-.5762023-.5531497-1.4862093-.5531497-2.06241151 0z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3F51AE'
    },
    rotate: {
      type: String,
      default: ''
    }
  },
  computed: {
    checkSide() {
      return ['up', 'down', 'left', 'right'].includes(this.rotate)
        ? `rotate-${this.rotate}`
        : ''
    }
  }
}
</script>